"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconHighSpeedEmergencyBreaking = function IconHighSpeedEmergencyBreaking(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "30",
    height: "30",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.0001 25.0001C45.9883 30.1976 44.0494 35.2062 40.5585 39.0569C37.0676 42.9077 32.2726 45.3271 27.1011 45.8471C21.9296 46.3671 16.749 44.9508 12.5613 41.8721C8.37362 38.7935 5.47641 34.2712 4.43005 29.1801C4.4034 29.0345 4.40938 28.8849 4.44755 28.7419C4.48572 28.599 4.55514 28.4663 4.6508 28.3534C4.74646 28.2405 4.86597 28.1503 5.00073 28.0892C5.13548 28.0281 5.28211 27.9976 5.43005 28.0001H7.43005C8.15005 28.0001 8.55005 28.3301 8.65005 28.7901C9.32284 31.7154 10.7667 34.4073 12.8316 36.586C14.8964 38.7646 17.507 40.3507 20.3921 41.1793C23.2772 42.0079 26.3316 42.0488 29.2379 41.2978C32.1441 40.5469 34.7963 39.0314 36.9188 36.9089C39.0414 34.7863 40.5569 32.1341 41.3078 29.2279C42.0588 26.3216 42.0178 23.2672 41.1892 20.3821C40.3606 17.497 38.7746 14.8864 36.5959 12.8216C34.4173 10.7567 31.7254 9.31285 28.8001 8.64007C28.5708 8.59332 28.3652 8.46764 28.219 8.28492C28.0728 8.10221 27.9953 7.87401 28.0001 7.64007V5.41007C27.9963 5.258 28.0273 5.10708 28.0907 4.96881C28.1541 4.83053 28.2482 4.70853 28.3658 4.61211C28.4835 4.51568 28.6216 4.44736 28.7696 4.41235C28.9176 4.37734 29.0717 4.37656 29.2201 4.41007C33.9614 5.38269 38.2212 7.96323 41.2789 11.7151C44.3365 15.4671 46.0043 20.16 46.0001 25.0001Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 3C18.509 3.2444 13.3084 5.53535 9.42189 9.42189C5.53535 13.3084 3.2444 18.509 3 24C3 24.2652 3.10536 24.5196 3.29289 24.7071C3.48043 24.8946 3.73478 25 4 25H8.23C8.48514 25.0005 8.73081 24.9034 8.91671 24.7286C9.10261 24.5539 9.21469 24.3147 9.23 24.06C9.45613 20.2006 11.0912 16.5585 13.8248 13.8248C16.5585 11.0912 20.2006 9.45613 24.06 9.23C24.3147 9.21469 24.5539 9.10261 24.7286 8.91671C24.9034 8.73081 25.0005 8.48514 25 8.23V4C25 3.73478 24.8946 3.48043 24.7071 3.29289C24.5196 3.10536 24.2652 3 24 3Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.596 24.2135L35.5626 18.2469C36.2058 17.6037 36.0947 16.4485 35.3136 15.6675C34.5326 14.8864 33.378 14.7747 32.7348 15.4179L27.0083 21.1444C25.5971 20.6389 23.9586 20.9514 22.8283 22.0817C21.2662 23.6438 21.2662 26.1764 22.8283 27.7385C24.3904 29.3006 26.9231 29.3006 28.4852 27.7385C29.4441 26.7796 29.8144 25.4549 29.596 24.2135Z",
    fill: color
  }));
};

IconHighSpeedEmergencyBreaking.defaultProps = {
  color: 'black'
};
IconHighSpeedEmergencyBreaking.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconHighSpeedEmergencyBreaking;
exports.default = _default;